/**
 * Iconos del chrome de escritorio (sidebar + topbar). Trazo 1.8 como en el
 * bundle V2 (claude-design/orborix-speak/V2 · desktop-screens.jsx).
 *
 * Set acotado a lo que usan DesktopSidebar / DesktopTopbar. Los iconos de la
 * conversación viven en screens/conversation/icons.tsx; los de la home móvil
 * en screens/home/icons.tsx.
 */

interface IconProps {
  size?: number;
}

const base = {
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.8,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
};

export function IconHomeD({ size = 18 }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} {...base}>
      <path d="M3 11 L 12 3 L 21 11 V 20 a 1 1 0 0 1 -1 1 H 15 V 14 H 9 V 21 H 4 a 1 1 0 0 1 -1 -1 Z" />
    </svg>
  );
}

export function IconChatD({ size = 18 }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} {...base}>
      <path d="M21 12 a 9 9 0 0 1 -13 8 L 3 21 L 4 17 A 9 9 0 1 1 21 12 Z" />
    </svg>
  );
}

export function IconBookD({ size = 18 }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} {...base}>
      <path d="M4 4 V 20 A 1 1 0 0 0 5 21 H 12 V 5 A 2 2 0 0 0 10 3 H 5 A 1 1 0 0 0 4 4 Z" />
      <path d="M20 4 V 20 A 1 1 0 0 1 19 21 H 12 V 5 A 2 2 0 0 1 14 3 H 19 A 1 1 0 0 1 20 4 Z" />
    </svg>
  );
}

export function IconStatsD({ size = 18 }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} {...base}>
      <line x1="5" y1="20" x2="5" y2="12" />
      <line x1="12" y1="20" x2="12" y2="6" />
      <line x1="19" y1="20" x2="19" y2="14" />
    </svg>
  );
}

export function IconUserD({ size = 18 }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} {...base}>
      <circle cx="12" cy="9" r="4" />
      <path d="M4 21 c 1 -4, 4 -6, 8 -6 s 7 2, 8 6" />
    </svg>
  );
}

export function IconChevronDownD({ size = 14 }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} {...base} strokeWidth={2}>
      <path d="M6 9 L 12 15 L 18 9" />
    </svg>
  );
}

